function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import _JSXStyle from "styled-jsx/style";
import { useState } from "react";
import TabsComponent from "components/core/tabs/tabs-component";
import TabComponent from "components/core/tabs/tab/tab-component";
import AssetComponent from "components/core/asset/asset-component";
import classnames from "classnames";
import { componentStyles } from "./board-views-tab.scss";
import DefaultProps from "./default-props";
const BoardViewsTab = (props)=>{
    const { distanceFromTop, activeTabId, fullSizeContent, tabsRenderer, onTabClick } = props;
    const [animationActive, setAnimationActive] = useState(true);
    const onTabClickCallBack = (index)=>{
        setAnimationActive(false);
        setTimeout(()=>setAnimationActive(true), 0);
        if (onTabClick) {
            onTabClick(index);
        }
    };
    const defaultTabsRenderer = ()=>{
        const { tabs, theme } = props;
        return tabs === null || tabs === void 0 ? void 0 : tabs.map((tab, index)=>{
            const { tabLabel, asset, tabId, image } = tab;
            return /*#__PURE__*/ _jsx(TabComponent, {
                tabId: tabId,
                label: tabLabel,
                color: theme,
                useXSMLabels: true,
                tabIcon: image,
                tabsWithIcons: true,
                children: /*#__PURE__*/ _jsx("div", {
                    className: classnames("asset-wrapper", {
                        "animation-active": animationActive
                    }),
                    children: /*#__PURE__*/ _createElement(AssetComponent, _object_spread_props(_object_spread({}, asset), {
                        key: index
                    }))
                })
            }, index);
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: `jsx-${componentStyles.__hash}` + " " + "board-views-tab-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `jsx-${componentStyles.__hash}` + " " + (classnames("tabs-component-wrapper", {
                    "full-size-content": fullSizeContent
                }) || ""),
                children: /*#__PURE__*/ _jsx(TabsComponent, {
                    onTabClick: onTabClickCallBack,
                    distanceFromTop: distanceFromTop,
                    activeTabId: activeTabId,
                    autoTransition: false,
                    role: "tabpanel",
                    children: tabsRenderer ? tabsRenderer() : defaultTabsRenderer()
                })
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
BoardViewsTab.defaultProps = DefaultProps;
export default BoardViewsTab;
